import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const HostCheckbox = ({ onChange, value }) => {
  const { t } = useTranslation();

  return (
    <Form.Group controlId="is_host" className="my-3 py-3 col-6">
      <Form.Check
        label={t("host")}
        type="checkbox"
        onChange={onChange}
        value={value}
        checked={Boolean(value)}
      />
    </Form.Group>
  );
};

export default HostCheckbox;
